import { render, staticRenderFns } from "./role.vue?vue&type=template&id=51716f61"
import script from "./role.vue?vue&type=script&lang=js"
export * from "./role.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports